import { useTranslation } from 'react-i18next';

import type { PeriodFilter } from '@/hooks';

import { Button } from '@/components/ui/button';

import { PERIOD_PRESETS } from '@/helpers';

import { PRESET_LABEL_KEYS } from './consts';
import { PeriodPicker } from './PeriodPicker';

type Props = {
  filter: PeriodFilter;
};

export const PeriodToolbar = (props: Props) => {
  const { filter } = props;
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-1">
        {PERIOD_PRESETS.map((preset) => (
          <Button
            key={preset}
            variant={filter.activePreset === preset ? 'default' : 'outline'}
            size="sm"
            onClick={() => filter.onPresetSelect(preset)}
          >
            {t(PRESET_LABEL_KEYS[preset])}
          </Button>
        ))}
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
        <PeriodPicker filter={filter} />
      </div>
    </div>
  );
};
